export const blockIconsNavigationMenu = (
	<span className='material-symbols-outlined'>menu</span>
);
